var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarketResearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.262 20.426L37.837 18 26.929 28.907l2.426 2.426 10.907-10.907zM47.557 18L29.355 36.202l-7.192-7.174-2.425 2.426 9.617 9.617L50 20.426 47.557 18zM10 31.454l9.617 9.617 2.426-2.426-9.6-9.617L10 31.454z",
    fill: "#E3B05F"
  })));
}

export default SvgMarketResearch;